module.exports = __webpack_public_path__ + "img/wz-7-3-3.c9afe635.jpg";